/** Wire values returned by the bill synchronization API. */
export enum BillSyncOperationDTO {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
}

export type BillSyncOperationResponse = BillSyncOperationDTO;
